import React from "react";
import { Container } from "react-bootstrap";
import VimeoPlayer from "../../../components/VimeoPlayer";

const films = [
  {
    title: "Romeo & Juliet Digital",
    url: "https://player.vimeo.com/video/1098390119?badge=0&autopause=0&player_id=0&app_id=58479",
    runtime: "1:23:33",
    format: "HD video, digital, color",
    year: "2024",
    description: "Romeo & Juliet is a contemporary dance-theater production set to Sergei Prokofiev's iconic ballet score. Using a chorus that sets up and propels the story forward, R&J tells the classic tale from a retrospective perspective. In an innovative blend of contemporary, ballet, and social and folk dance forms, the production introduces a new theatrical genre to the Harvard community.",
    credits: "Featuring: Romeo & Juliet Cast\nCamera, Sound, Edit: Sky Jung",
    link: "https://harvardromeojuliet.carrd.co/",
  },
  {
    title: "The Bedroom: Italian Neorealist and German Expressionist Depictions of Space",
    url: "https://player.vimeo.com/video/1103259497?badge=0&autopause=0&player_id=0&app_id=58479",
    runtime: "3:59",
    format: "HD video, digital, bw",
    year: "2023",
    description: "Italian neorealism and German expressionism are two prominent film movements that emerged in the early 20th century. Both movements rejected the artificiality of Hollywood-esque productions and instead embraced a realistic approach to storytelling—one that captured the raw human experience. The four films selected for this visual essay (Sunrise: A Song of Two Humans, L'Atalante, Bicycle Thieves, and The Cabinet of Dr. Caligari) are exemplary works from these movements, each utilizing the bedroom as a significant location for intimate character exploration. In these films, the bedroom serves as a silent witness to the human experience, housing raw emotions, complexities of married life and family dynamics, and intimacy in romantic relationships.",
    credits: "Sound, Edit: Sky Jung",
    link: "https://vimeo.com/1103259497?share=copy#t=0",
  },
];

function Film() {
  const grouped = films.reduce((acc, film) => {
    (acc[film.year] = acc[film.year] || []).push(film);
    return acc;
  }, {});

  const years = Object.keys(grouped).sort((a, b) => b - a);

  return (
    <Container className="film-section">
      <div className="film-page">
        {years.map((year) => (
          <section key={year} className="film-year-section">
            <h2 className="art-year-heading">{year}</h2>
            {grouped[year].map((film, i) => (
              <div key={i} className="film-scroll-item">
                <VimeoPlayer url={film.url} />
                <div className="film-label">
                  <label>{film.title}</label>
                  <p>Total run time: {film.runtime}<br />{film.format}</p>
                  <br />
                  <p>{film.description}<br /><br />{film.credits}</p>
                  <a target="_blank" rel="noopener noreferrer" href={film.link} style={{ fontSize: 'xx-small' }}>more info</a>
                </div>
              </div>
            ))}
          </section>
        ))}
      </div>
    </Container>
  );
}

export default Film;
